var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wechat-toast"},[(_vm.show)?[_c('img',{attrs:{"src":require(`../../assets/img/components/wechatBinding/${_vm.imgUrl}`),"alt":""}}),_c('div',{staticClass:"content-text"},[_vm._v(_vm._s(_vm.typeInfoData.text))])]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }